import { ListItemIcon, ListItemText, MenuItem, Typography } from '@mui/material';

export default function NavMenuItem({ text, textStyle, icon, clickFn, itemStyle }) {
    return (
        <MenuItem onClick={clickFn} sx={{ ...itemStyle }}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText><Typography textAlign="left" sx={{ ...textStyle }}>{text}</Typography></ListItemText>
        </MenuItem>
    )
}